<template>
  <v-content class="client campaign analytics page">
    <v-progress-linear
      v-if="loading"
      :color="themes.client.light.input"
      indeterminate
      class="my-0"
    />

    <v-container class="py-0">
      <v-layout column>
        <v-toolbar flat color="transparent">
          <v-toolbar-title>Campaign Analytics</v-toolbar-title>
        </v-toolbar>
      </v-layout>
    </v-container>

    <!-- General Section -->
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm6>
          <AnalyticsCard
            icon="mdi-badge-account-outline"
            title="Recent Campaign Signups"
            path="client/organization/analytics/signups"
            info="Signups from your campaigns in the past week"
          />
        </v-flex>

        <v-flex xs12 sm6>
          <AnalyticsCard
            icon="mdi-account-arrow-left"
            title="Total Campaign Signups"
            path="client/organization/analytics/all_signups"
            info="Signups from your campaigns across all time"
          />
        </v-flex>

        <SignupSourcesCard />
        <ApplicationSourcesCard />
      </v-layout>
    </v-container>

    <!-- Campaign Section -->
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 v-if="!loading && campaigns.length === 0">
          <v-card flat color="transparent">
            <v-card-text class="text-xs-center">
              <em>No campaigns to show. Create a new campaign to get started.</em>
            </v-card-text>
          </v-card>
        </v-flex>
        <CampaignCard
          v-for="campaign in sortedCampaigns"
          :key="`campaign-${campaign.slug}`"
          :campaign="campaign"
        />
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
// Mixins
import { managedDocumentAttributes } from '@/mixins/managedDocumentAttributes'

// Components
import AnalyticsCard from '@/components/client/analytics/AnalyticsCard'
import CampaignCard from '@/components/client/analytics/CampaignCard'
import ApplicationSourcesCard from '@/components/client/analytics/ApplicationSourcesCard'
import SignupSourcesCard from '@/components/client/analytics/SignupSourcesCard'

// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  mixins: [managedDocumentAttributes],
  components: {
    AnalyticsCard,
    CampaignCard,
    ApplicationSourcesCard,
    SignupSourcesCard,
  },
  created() {
    this.documentAttributes.title = `Campaign Analytics – Leaply`
    Promise.all([
      this.$store.dispatch('client/organization/fetch', this.$route.params.id).then(() => {
        this.documentAttributes.title = `${this.organization.name} Analytics - Leaply`
      }),
      this.$store.dispatch('client/opportunities/fetchAll'),
      this.$store.dispatch('client/campaigns/fetchAll'),
    ]).finally(() => (this.loading = false))
  },
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    ...mapGetters({
      campaigns: 'client/campaigns/all',
      opportunities: 'client/opportunities/all',
      organization: 'client/organization/model',
    }),
    sortedCampaigns() {
      return _.reverse(_.sortBy(this.campaigns.filter(c => !c.hiddenAt), c => c.createdAt))
    }
  },
}
</script>

<style lang="scss">
.client.analytics.page {
  .v-toolbar__content {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
